import React from 'react';
import {Alert, Spin} from 'antd';
// import {AgGridReact} from 'ag-grid-react';
import AgGrid from '../common/AgGrid';
import {
    AG_GRID_DEFAULT_COL_DEF,
    AG_GRID_DEFAULT_PAGE_SIZE,
    AG_GRID_LOCALE_TEXT,
    AG_GRID_PAGE_SIZE_OPTIONS,
} from '../../config/agGridConfig';

// 재사용 가능한 AG-Grid 패널 래퍼
// props: { rowData, columnDefs, pageSize, height, loading, error, defaultColDef, gridProps, gridRef, onRowDoubleClicked, getContextMenuItems }
const ProjectAgGridPanel = ({
  rowData = [],
  columnDefs = [],
  pageSize = AG_GRID_DEFAULT_PAGE_SIZE,
  loading = false,
  error = '',
  defaultColDef = AG_GRID_DEFAULT_COL_DEF,
  gridProps = {},
  gridRef,
  onRowDoubleClicked,
  getContextMenuItems,
}) => {
  return (
    <div style={{ width: '100%' }}>
      {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} />}
      <Spin spinning={loading}>
        <div style={{ width: '100%' }}>
          <AgGrid
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            paginationPageSize={pageSize}
            paginationPageSizeSelector={AG_GRID_PAGE_SIZE_OPTIONS}
            rowSelection="multiple"
            enableCellTextSelection={true}
            suppressDragLeaveHidesColumns={true}
            localeText={AG_GRID_LOCALE_TEXT}
            onRowDoubleClicked={onRowDoubleClicked}
            getContextMenuItems={getContextMenuItems}
            {...gridProps}
          />
        </div>
      </Spin>
    </div>
  );
};

export default ProjectAgGridPanel;
